import { useEffect, useState } from 'react';
import Button from '../../../../components/common/button';
import Table from '../../../../components/common/table';
import View from '../../../../assets/icons/view.svg';
import { getBusinessTypes, updateBusinessType } from '../../../../api/business';
import Trash from '../../../../assets/icons/trash.svg';
import { useDispatch } from 'react-redux';
import { resetText } from '../../../../store/slices/textSlice';
import BusinessTypeFormModal from './businessTypeFormModal';
import colors from '../../../../share/constants/constants';
import DeleteMemberModal from '../../../../components/common/modalMember';
import { message } from 'antd';

const ManageBusinessTypes = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState([]);
  const [selectedBType, setSelectedBType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const columns = [
    {
      title: "Business Type",
      dataIndex: "name",
      key: "businessTypeName",
    },
    {
      title: "Business Cost ($)",
      className: "column-money",
      render: (text) => <>${text}</>,
      dataIndex: "cost",
      key: "businessCost",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-2 w-[100px]">
          <div
            onClick={() => showModal(record)}
            className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightLavender cursor-pointer"
          >
            <img src={View} alt="View" />
          </div>
          <div
            className="flex items-center justify-center w-4 h-4  rounded-full bg-lightLavender cursor-pointer"
            onClick={() => handleDeleteCategory(record)}
          >
            <img src={Trash} alt="View" />
          </div>
        </div>
      ),
    },
  ];

  const handleDeleteCategory = (value) => {
    setIsDeleteModalOpen(value?._id);
  };

  const deleteBusinessType = async () => {
    const deleteResponse = await updateBusinessType(isDeleteModalOpen, {
      isDeleted: true,
    });
    if (deleteResponse) {
      message.success('Business Type Deleted Successfully!');
    }
  };

  const YesClickHandler = async () => {
    await deleteBusinessType();
    hideModal();
  };

  const hideModal = () => {
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
  };

  const showModal = (bType) => {
    setIsModalOpen(true);
    setSelectedBType(bType);
  };

  useEffect(() => {
    dispatch(resetText());
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await getBusinessTypes();
        setResult(res);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isDeleteModalOpen, isModalOpen]);

  return (
    <div className="grid gap-2 w-full">
      <div className="flex justify-between">
        <div className="flex pt-3 pl-1">
          <div className="flex items-center">
            <span className="text-lg font-bold text-black ml-1">
              Business Types
            </span>
          </div>
        </div>
        <div className="mt-2 mr-2">
          <Button
            title="Add Business Type"
            className="w-15.8 h-3.8 br"
            borderRadius={5}
            onClick={showModal}
            color={colors.primaryPurple}
          />
        </div>
      </div>

      <div>
        <div>
          <div className="min-h-screen flex items-start justify-start pt-0">
            <Table columns={columns} data={result} loading={loading} />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <BusinessTypeFormModal
          data={
            selectedBType
              ? selectedBType
              : { name: '', cost: '' }
          }
          onCancel={hideModal}
          onOk={hideModal}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteMemberModal
          title="Delete Business Type"
          text="Are you sure you want to delete this business type?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
    </div>
  );
};
export default ManageBusinessTypes;
